module.exports = __webpack_public_path__ + "static/media/_AmountSelection.0b6c45ab.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/AmountSelectionSwishMC/_AmountSelection.scss
// module id = 445
// module chunks = 0